import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SnCamera } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class DispatchDirectPayloadAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getNearbyCameras(lat: number, lon: number): Observable<any> {
    return this._httpClient
      .get('/api/dispatch_direct/', {
        params: {
          incident_lat_lon: [lat.toString(), lon.toString()].join(','),
          miles_radius: '0.5',
          viewable_range_degrees: '40',
        },
      })
      .pipe(map((response: any) => response.map((camera) => new SnCamera(camera))));
  }
}
